var map = {
	"./Bicycles_Thumb_1.jpg": 664,
	"./Coffee_Thumb_1.jpg": 665,
	"./Handbags_Thumb_1.jpg": 666,
	"./Paper_Thumb_1.jpg": 667,
	"./Semiconductors_Thumb_1.jpg": 668,
	"./flowers_Thumb_1.jpg": 669,
	"./spices_Thumb_1.jpg": 670,
	"./whisky_thumb_1.jpg": 671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 663;